import { TypeProduct, TypeProductFields } from '@/core/generated-types';
import { ShopifyVariant } from '@/lib/shopify';
import { SelectedAddOns } from '../ProductAddToCart/ProductAddToCart';
import { formatMoney } from '@/utils/helpers';
import { formatCentsToDollars } from '@/components/subflow-v3/components/utils';
import { EntryFields } from 'contentful';
export interface ProductAddOnsProps {
  productAddOns?: TypeProduct[];
  selectedAddOns: SelectedAddOns[];
  setSelectedAddOns: (selectedAddOns: SelectedAddOns[]) => void;
  productFields: TypeProductFields;
  defaultVariant: ShopifyVariant;
  isPlaythingProduct?: boolean;
  subscribeCtaMessage?: EntryFields.RichText;
}

export const calculateCartTotal = (
  defaultVariant: ShopifyVariant,
  selectedAddOns: SelectedAddOns[],
  locale: string,
) => {
  const defaultPrice = Number(defaultVariant.price?.amount ?? 0);

  const cartTotal = selectedAddOns.reduce((acc, selectedAddOn) => {
    const price = Number(
      (formatCentsToDollars(selectedAddOn.variant.priceCentsStandalone) ||
        selectedAddOn.variant.price?.amount) ??
        0,
    );
    return acc + price;
  }, defaultPrice);

  return {
    // total including the product price and add-ons
    cartTotal: formatMoney(cartTotal, locale),
    // total for the add-ons only (excluding the main product price)
    addonsTotal: formatMoney(cartTotal - defaultPrice, locale, false),
  };
};

export const getCartList = (
  productTitle: string,
  selectedAddOns: SelectedAddOns[],
) => {
  const addOnTitles = selectedAddOns
    .map((selectedAddOn) => selectedAddOn.fields.title)
    .join(', ');
  const addOnTitlesList = addOnTitles ? `, ${addOnTitles}` : '';
  return `${productTitle}${addOnTitlesList}`;
};

export const announceChangeForScreenReader = (
  action: 'added' | 'removed',
  itemName: string,
) => {
  const announcement =
    action === 'added'
      ? `${itemName} added to cart`
      : `${itemName} removed from cart`;
  // Create temporary announcement element
  const announcer = document.createElement('div');
  announcer.setAttribute('aria-live', 'polite');
  announcer.setAttribute('aria-atomic', 'true');
  announcer.className = 'sr-only';
  document.body.appendChild(announcer);
  announcer.textContent = announcement;
  setTimeout(() => document.body.removeChild(announcer), 1000);
};
